(function () {
  'use strict';

  var controlLabels = [
    [/slick-prev|prev-arrow|previous/i, 'Previous item'],
    [/slick-next|next-arrow/i, 'Next item'],
    [/mfp-close|modal-close|close/i, 'Close dialog'],
    [/search/i, 'Search'],
    [/menu|nav-toggle/i, 'Open menu'],
    [/cart/i, 'Open cart']
  ];

  function setIntrinsicSize(image) {
    if (image.getAttribute('width') && image.getAttribute('height')) return;
    if (!image.naturalWidth || !image.naturalHeight) return;
    image.setAttribute('width', image.naturalWidth);
    image.setAttribute('height', image.naturalHeight);
  }

  function enhanceImage(image) {
    if (!image.getAttribute('decoding')) image.setAttribute('decoding', 'async');

    if (
      !image.getAttribute('loading') &&
      !image.classList.contains('product-featured-img') &&
      image.getBoundingClientRect().top > window.innerHeight * 1.25
    ) {
      image.setAttribute('loading', 'lazy');
    }

    if (image.complete) setIntrinsicSize(image);
    else image.addEventListener('load', function () { setIntrinsicSize(image); }, { once: true });

    if (!image.hasAttribute('alt')) {
      var link = image.closest('a[aria-label], a[title]');
      var label = link && (link.getAttribute('aria-label') || link.getAttribute('title'));
      if (label) image.setAttribute('alt', label);
    }
  }

  function accessibleName(control) {
    return (
      (control.textContent || control.value || '').trim() ||
      control.getAttribute('aria-label') ||
      control.getAttribute('aria-labelledby') ||
      control.getAttribute('title') ||
      (control.id && document.querySelector('label[for="' + CSS.escape(control.id) + '"]')) ||
      control.closest('label')
    );
  }

  function enhanceControl(control) {
    if (accessibleName(control)) return;
    var hiddenLabel = control.querySelector('.visually-hidden, .tooltip-label');
    if (hiddenLabel && hiddenLabel.textContent.trim()) {
      control.setAttribute('aria-label', hiddenLabel.textContent.trim());
      return;
    }

    var signature = [control.id, control.className, control.getAttribute('data-action')]
      .filter(Boolean)
      .join(' ');
    for (var i = 0; i < controlLabels.length; i += 1) {
      if (controlLabels[i][0].test(signature)) {
        control.setAttribute('aria-label', controlLabels[i][1]);
        return;
      }
    }
  }

  function enhanceDialog(dialog) {
    if (!dialog.getAttribute('role')) dialog.setAttribute('role', 'dialog');
    dialog.setAttribute('aria-modal', 'true');
    if (!dialog.getAttribute('aria-label') && !dialog.getAttribute('aria-labelledby')) {
      var heading = dialog.querySelector('h1, h2, h3, .h1, .h2, .h3');
      if (heading) {
        if (!heading.id) heading.id = 'gd-dialog-title-' + Math.random().toString(36).slice(2, 9);
        dialog.setAttribute('aria-labelledby', heading.id);
      } else {
        dialog.setAttribute('aria-label', 'Store dialog');
      }
    }
  }

  function enhance(root) {
    var scope = root && root.querySelectorAll ? root : document;
    if (root && root.matches && root.matches('img')) enhanceImage(root);
    scope.querySelectorAll('img').forEach(enhanceImage);

    if (root && root.matches && root.matches('button, [role="button"]')) enhanceControl(root);
    scope.querySelectorAll('button, [role="button"]').forEach(enhanceControl);

    if (root && root.matches && root.matches('.mfp-wrap, .modal-prompt, dialog')) enhanceDialog(root);
    scope.querySelectorAll('.mfp-wrap, .modal-prompt, dialog').forEach(enhanceDialog);
  }

  function init() {
    enhance(document);
    var observer = new MutationObserver(function (records) {
      records.forEach(function (record) {
        record.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) enhance(node);
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
